<template>
  <div class="relative bg-indigo-600">
    <div class="max-w-7xl mx-auto py-3 px-3 sm:px-6 lg:px-8">
      <div class="pr-16 sm:text-center sm:px-16">
        <p
          class="font-medium text-white"
          @click="showInterestOnWhatsappBroadcast"
        >
          <span class="inline">
            Increase your average order value with our new app 
          </span>
          <span class="block sm:ml-2 sm:inline-block">
            <a class="text-white font-bold underline cursor-pointer">
              click for more details
              <span aria-hidden="true">&rarr;</span></a
            >
          </span>
        </p>
      </div>
      <div
        class="absolute inset-y-0 right-0 pt-1 pr-1 flex items-start sm:pt-1 sm:pr-2 sm:items-start"
      >
        <button
          type="button"
          class="flex p-2 rounded-md hover:bg-indigo-500 focus:outline-none focus:ring-2 focus:ring-white"
          @click="closePromoBanner"
        >
          <span class="sr-only">Dismiss</span>
          <!-- Heroicon name: outline/x -->
          <svg
            class="h-6 w-6 text-white"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            aria-hidden="true"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    gotoNewAutomationPromoPage() {
      this.$router.push({ name: "TeamInbox" });
    },
    closePromoBanner() {
      this.$emit("close");
    },
    showInterestOnWhatsappBroadcast() {
      window.open(
        "https://apps.shopify.com/ck-volume-discount",
        "_blank"
      );
      // this.$router.push({
      //   name: "Instagram"
      // });

      //       $crisp.push(["do", "chat:open"]); // eslint-disable-line
      //       // eslint-disable-next-line
      //       $crisp.push([
      //         "do",
      //         "message:show",
      //         [
      //           "text",
      //           `Hello!

      // If you would like to send from your own number. It's part of our advanced plan and we will apply to whatsapp business API for your number.

      // Also note that when we apply for official WhatsApp api. You won't be able to use that number on mobile except via api.

      // In order to proceed with the application we need few of your details

      // 1) Facebook business manager Id
      // 2) Facebook page URL
      // 3) Business name as registered in Facebook business manager
      // 4) Your business physical address
      // 5) Your current WhatsApp number to reach for approval related data.
      // 6) Phone number which will be used to apply. (this number should not be connected to whatsapp business / whatsapp personal account)`
      //         ]
      //       ]);
      // $crisp.push([
      //   "set",
      //   "message:text",
      //   ["Hi I Would like to send automated messages from my whatsapp number."]
      // ]);
    }
  }
};
</script>

<style lang="scss" scoped></style>
